import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, TimeoutError } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isHomeIaRequest =
      (environment.homeIaApiUrl && req.url.includes(environment.homeIaApiUrl)) ||
      req.url.includes('/api/home-ia');
    const isMutation = ['POST', 'PATCH', 'PUT', 'DELETE'].includes(req.method.toUpperCase());

    const homeIaTimeoutMs = isMutation
      ? (environment.homeIaApiMutationTimeoutMs ?? environment.requestTimeoutMs)
      : (environment.homeIaApiTimeoutMs ?? environment.requestTimeoutMs);

    const timeoutMs = isHomeIaRequest ? homeIaTimeoutMs : environment.requestTimeoutMs;

    return next.handle(req).pipe(
      timeout(timeoutMs),
      catchError((err) => {
        if (err instanceof TimeoutError) {
          throw new Error('La solicitud ha superado el tiempo máximo de espera.');
        }
        throw err;
      })
    );
  }
}
